<template>
  <div
    id="banner-container"
    v-on="
      lessThan974
        ? {}
        : {
            mouseover: () => (objectInfoHover = true),
            mouseleave: () => (objectInfoHover = false),
          }
    "
  >
    <!-- <img 
    src="../assets/banner.jpg" 
    alt="Detail from glass mosque lamp of knotwork design"
  > -->
    <!-- <img 
    :src="getBannerImage()"
    alt="Detail from glass mosque lamp of knotwork design"
  > -->
    <img
      v-show="imageURL.length > 0"
      :src="imageURL"
      :alt="`Detail from ${objectInfo.name}`"
    />
    <div
      id="banner-copyright"
      v-show="objectInfoLoaded && !lessThan974 && objectInfoHover"
    >
      <span
        id="banner-copyright-name"
        v-html="`Detail from ${objectInfo.name}`"
      ></span>
      <span v-if="objectInfo.partnerName">{{ objectInfo.partnerName }}</span>
      <span>{{ objectInfo.location }}, {{ objectInfo.countryName }}</span>
    </div>
    <div id="banner-text">
      <div id="banner-galleries-text">Discover MWNF Galleries</div>
      <div>
        {{ dxaFull }}
        <router-link :to="{ path: '/collection' }">
          <font-awesome-icon :icon="['fas', 'angles-right']"></font-awesome-icon>
        </router-link>
      </div>
    </div>
  </div>
</template>



<script>
import banners from "../mixins/banners.js";
import media from "../mixins/media.js";
export default {
  name: "BannerComponent",
  mixins: [banners, media],
  data() {
    return {
      lessThan974: window.matchMedia("(max-width: 974px)").matches,
      dxaFull: process.env.VUE_APP_DXA_FULL,
      imageURL: "",
      objectURL: "",
      objectInfo: {},
      objectInfoLoaded: false,
      objectInfoHover: false,
    };
  },
  mounted() {
    this.getBannerLinks().then(() => {
      this.checkIE("banner-container");
    });
  },
};
</script>



<style scoped lang="scss">
#banner-container {
  position: relative;
  height: 45vh;
  max-height: 450px;
  width: 100%;
}
#banner-container img {
  @include image-scale;
  object-fit: cover;
}
#banner-copyright {
  @include flex-center;
  flex-direction: column;
  align-items: flex-start;
  position: absolute;
  right: 0;
  bottom: 0;
  max-width: 20%;
  color: rgba(255, 255, 255, 0.8);
  font-size: 90%;
  font-style: italic;
  background-color: rgba(0, 0, 0, 0.6);
  padding: 15px;
  margin: 15px;
}
#banner-copyright-name {
  font-weight: bold;
  margin-bottom: 10px;
}
#banner-text {
  @include flex-center;
  flex-direction: column;
  position: absolute;
  top: 0;
  bottom: 0;
  width: 100%;
  color: $light-text;
  font-size: 70px;
  font-weight: bold;
  text-align: center;
  text-shadow: 0 0 30px black;
  padding: 0 50px;
  a {
    filter: drop-shadow(0 0 30px black);
  }
}
#banner-galleries-text {
  font-size: 30px;
}
#banner-text i {
  font-size: 50px;
  padding-left: 14px;
}
#banner-text a {
  color: $light-text;
}

/* IE-only */
@media only screen and (-ms-high-contrast: none), (-ms-high-contrast: active) {
  #banner-container {
    background-size: cover;
    background-position: center;
  }
  #banner-container img {
    display: none;
  }
}

@media only screen and (max-width: 1199px) {
  #banner-text {
    font-size: 60px;
  }
  #banner-text i {
    font-size: 45px;
  }
}

@media only screen and (max-width: 849px) {
  #banner-text {
    font-size: 54px;
  }
  #banner-galleries-text {
    font-size: 25px;
  }
  #banner-text i {
    font-size: 40px;
  }
}

@media only screen and (max-width: 724px) {
  #banner-container {
    height: 32vh;
  }
  #banner-text {
    font-size: 45px;
  }
  #banner-galleries-text {
    font-size: 22px;
  }
  #banner-text i {
    font-size: 32px;
  }
}

@media only screen and (max-width: 599px) {
  #banner-container {
    height: 150px;
  }
  #banner-text {
    font-size: 36px;
  }
  #banner-galleries-text {
    font-size: 20px;
  }
  #banner-text i {
    font-size: 30px;
  }
}

@media only screen and (max-width: 499px) {
  #banner-text {
    font-size: 32px;
    padding: 0 25px;
  }
  #banner-text i {
    font-size: 28px;
  }
}
</style>